module.exports = __webpack_public_path__ + "imgs/ColorOfChange.76608546646400af1735fd3b202381e2.png";